import axios from 'axios';

const state = {
  coupons: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null
  }
};

const actions = {
  async fetchCoupons({ commit, dispatch }, params) {
    dispatch('loading/showLoading', null, { root: true });
    
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/coupons`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: params
      });
      const data = await response.data;
      commit('setCoupon', data);
      commit('setPagination', data.pagination);
    }
    catch (error) {
      console.error('Failed to fetch coupon: ', error);
    }
    finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },
  async fetchAllCoupons({ commit }) {
    
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/coupons`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      const data = await response.data;
      commit('setCoupon', data);
      commit('setPagination', data.pagination);
    }
    catch (error) {
      console.error('Failed to fetch coupon: ', error);
    }
  },

  async createCoupon({ commit }, coupon) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.post(`${process.env.VUE_APP_ROOT_API}/coupons`, coupon, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      commit('addCoupon', response.data);
    }
    catch (error) {
      console.error('Failed to create coupon:', error);
    }
  },

  async updateCoupon({ commit }, coupon) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/coupons/${coupon.id}`, coupon, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      commit('updateCoupon', response.data);
    }
    catch (error) {
      console.error('Failed to update Coupon:', error);
      throw error;
    }
  },

  async deleteCouponById({ commit }, id) {
    try {
      const token = localStorage.getItem('auth_token');
      await axios.delete(`${process.env.VUE_APP_ROOT_API}/coupons/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      commit('removeCoupon', id);
    } catch (error) {
      console.error('Failed to delete coupon:', error);
    }
  },
  async fetchCouponId(_, coupon_id) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/coupons/${coupon_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return response.data;
    }
    catch (error) {
      console.error('Failed to fetch coupon by ID:', error);
      throw error;
    }
  },
};

const mutations = {
  setCoupon(state, coupons) {
    state.coupons = coupons.data;
  },
  setPagination(state, pagination) {
    state.pagination.page = pagination.page || 1;
    state.pagination.perPage = pagination.perPage || 10;
    state.pagination.totalItems = pagination.totalItems || 0;

    state.pagination.previousPageLink = pagination.previousPageLink ? pagination.previousPageLink.replace(/\/api\/v1\/coupons\?/, '') : null;
    state.pagination.nextPageLink = pagination.nextPageLink ? pagination.nextPageLink.replace(/\/api\/v1\/coupons\?/, '') : null;
  },
  addCoupon(state, coupon) {
    state.coupons.push(coupon);
  },
  updateCoupon(state, updatedCoupon) {
    const index = state.coupons.findIndex(coupon => coupon.id === updatedCoupon.id);
    if (index !== -1) {
      state.coupons.splice(index, 1, updatedCoupon);
    }
  },

  removeCoupon(state, id) {
    state.coupons = state.coupons.filter(coupon => coupon.id !== id);
  }
};

const getters = {
  allCoupon: (state) => state.coupons,
  pagination: (state) => state.pagination
};

export default {
  namespaced:true,
  state, mutations, actions, getters,
};